import React from "react";
import { getClassName } from "@sscs/utils";
import { normalizePercentageValue } from "../utils";
import styles from "./percentageBars.module.scss";
const PercentageBars = ({ riskEvaluationCounters, totalEvaluatedPolicies, }) => {
    const percentages = normalizePercentageValue(riskEvaluationCounters, totalEvaluatedPolicies);
    const passCount = totalEvaluatedPolicies -
        riskEvaluationCounters.failCount -
        riskEvaluationCounters.warningCount;
    const segments = [
        {
            status: "fail",
            label: "Fail",
            count: riskEvaluationCounters.failCount,
            percentage: percentages.fail,
        },
        {
            status: "warning",
            label: "Warning",
            count: riskEvaluationCounters.warningCount,
            percentage: percentages.warning,
        },
        {
            status: "pass",
            label: "Pass",
            count: passCount,
            percentage: percentages.pass,
        },
    ].filter((segment) => segment.count > 0);
    return (React.createElement("div", { className: styles["percentage-bars"] },
        React.createElement("div", { className: styles.bar }, segments.map(({ status, percentage }) => (React.createElement("span", { key: status, className: styles[status], style: { flexGrow: percentage } })))),
        React.createElement("div", { className: styles.legend }, segments.map(({ status, label, count, percentage }, index) => (React.createElement(React.Fragment, { key: status },
            index > 0 ? (React.createElement("span", { className: styles.separator, "aria-hidden": "true" })) : null,
            React.createElement("span", { className: styles["legend-item"] },
                React.createElement("span", { className: getClassName(styles.swatch, styles[status]) }),
                label,
                " ",
                count.toLocaleString(),
                "/",
                totalEvaluatedPolicies.toLocaleString(),
                " (",
                percentage,
                "%)")))))));
};
export default PercentageBars;
//# sourceMappingURL=PercentageBars.js.map